import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toInteger, isEmpty } from 'lodash';

import { PATH } from '../../../../constants/path';
import directoryService from '../../../../services/directory';

import { clearFilter, filterPartnerOnCategory } from '../../../../services/filter/actions';

import { formatCategoryNameForUrl } from '../../../../services/category/utils';
import { buildPathPrefix } from '../../../../utils/directoryUtils';

import SortSelectComponent from './SortSelectComponent';
import ButtonComponent from '../../../button/ButtonComponent';
import NumberDisplayComponent from './NumberDisplayComponent';
import CategorySelectComponent from './CategorySelectComponent';

import './FilterComponent.scss';

class FilterComponent extends React.Component {
    buildPathPrefix = () =>
        buildPathPrefix(
            this.props.locale,
            this.props.isCodePromo,
            this.props.isOffline,
            this.props.isEbon
        );

    /**
     * Click handler Button A-Z
     */
    onClickBtTriAZ = e => {
        e.preventDefault();
        this.props.history.push(
            `${this.buildPathPrefix()}/${PATH.ALPHA_PATH}/${
                directoryService.constants.ABCBOOK_DEFAULT_LETTER
            }`
        );
    };

    /**
     * Change handler on Category select
     * @param {Integer} id
     */
    onChangeCategory = id => {
        const { categories, history } = this.props;

        if (toInteger(id) > 0) {
            const category = categories.filter(curr => toInteger(curr.id) === toInteger(id))[0];

            // on change l'url pour qu'elle matche avec le choix de la catégorie
            // les dispatch pour changer le store se font dans componentWillReceiveProps d'AnnuairePage
            if (!isEmpty(category)) {
                history.push(
                    `${this.buildPathPrefix()}/${PATH.CATEGORY_PATH}/${formatCategoryNameForUrl(
                        category.label
                    )}-${category.id}`
                );
            }

            this.props.filterPartnerOnCategory('directory', Number(category.id));
        } else {
            history.push(`${this.buildPathPrefix()}/${PATH.MOST_POPULAR_PATH}`);
            this.props.clearFilter('directory');
        }
    };

    render() {
        const { partners, isCodePromo, categories, categoryId, isOffline, isEbon } = this.props;
        return (
            <form className="annuaire-filtre flex-container-h flex-center-alt">
                <NumberDisplayComponent partners={partners} isCodePromo={isCodePromo} />
                <div className="filtre-conteneur flex-container-h flex-center-alt">
                    <CategorySelectComponent
                        categories={categories}
                        categoryId={categoryId}
                        onChangeCategory={this.onChangeCategory}
                    />
                    <ButtonComponent
                        text="A-Z"
                        color="third"
                        onClick={this.onClickBtTriAZ}
                        cssClass="bt-az"
                    />
                    <SortSelectComponent
                        categories={categories}
                        isCodePromo={isCodePromo}
                        isOffline={isOffline}
                        isEbon={isEbon}
                    />
                </div>
            </form>
        );
    }
}

FilterComponent.propTypes = {
    partners: PropTypes.array,
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    categories: PropTypes.array.isRequired,
    categoryId: PropTypes.number.isRequired
};

const mapDispatchToProps = {
    filterPartnerOnCategory,
    clearFilter
};

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterComponent));



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/FilterComponent.js